import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'

export default {
	name: 'StockCorrection',
	components: {
		Paginate,
		Loader,
		BasicSelect

	},
	data: function () {
		return {
			listBoxtypeData: [],
			listboxdata: [],
			ClientErr: '',
			WarehouseErr: '',
			StockcorrErr: '',
			RackErr: '',
			ProductErr: '',
			MRPErr: '',
			QuantityrErr: '',
			CorrectionreasonErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			addboxemodal: false,
			pageno: 0,
			pagecount: 0,
			id: '',
			client: '',
			warehouse: '',
			boxtype: '',
			length: '',
			breadth: '',
			height: '',
			boxcreate: '',
			quantity: [],
			warehouseid: '',
			createdbyuserid: '',
			selected: null,
			mrp: '',
			qty: '',
			correctionreason: '',
			correctiontype: '',
			isMultiseller: false,
			stockupdate: {
				correctiontype: null,
				rackid: '',
				productid: '',
				mrp: '',
				lotnumber: '',
				qty: '',
				mfgdate: '',
				shelflife: '',
				expirydate: '',
				correctionreason: null,
				comments: '',
			},
			correctiontypes: [{
				value: null,
				text: this.$t('auditReport.selectCorrectionReason'),
				disabled: true
			},
			{
				value: 'receipt',
				text: 'Receipt'
			},
			{
				value: 'issue',
				text: 'Issue'
			}
			],
			correctionreasons: [{
				value: null,
				text: this.$t('auditReport.selectCorrectionReason'),
				disabled: true
			},
			{
				value: 'System issue',
				text: 'System issue'
			},
			{
				value: 'User mistake',
				text: 'User mistake'
			},
			{
				value: 'Manual process',
				text: 'Manual process'
			},
			{
				value: 'Others',
				text: 'Others'
			},

			],
			rackiderror: '',
			isnotvalidrackid: false,
			invalidRackMessage: this.$t('auditReport.InvalidrackId'),
			isvalidrackid: false,
			isvalidproductid: false,
			isnotvalidproductid: false,
			isvalidmrp: false,
			isnotvalidmrp: false,
			rackisnotvalidmrp: false,
			isvalidlotnumber: false,
			isnotvalidlotnumber: false,
			producterrormsg: '',
			islotcontrol: 0,
			isexpirycontrol: 0,
			loterrormsg: '',
			whcurrentstock: 0,
			qtyerror: false,
			qtyerrormsg: '',
			mfgerrormsg: '',
			mfgerror: false,
			shelflifeerror: false,
			shelflifeerrormsg: '',
			expirydateerror: false,
			expirydateerrormsg: '',
			clientid: '',
			listClientData: [],
			listWarehouseData: [],
			useremail: '',
			user_type: '',
			isLoading: false,
			listmrpData: [],
			selectedmrp: { value: '', text: '' },
			mrpList: []
		}
	},
	created: function () { },
	computed: {
		isComplete1() {
			if (this.islotcontrol == 0) {
				if (this.isvalidrackid && this.isvalidproductid && this.isvalidmrp && !this.qtyerror && this.stockupdate.qty != '') {
					return true;
				} else {
					return false;
				}
			} else if (this.islotcontrol == 1) {
				if (this.isvalidrackid && this.isvalidproductid && this.isvalidmrp && this.isvalidlotnumber && !this.qtyerror && this.stockupdate.qty != '') {
					return true;
				} else {
					return false;
				}
			}
		},
	},
	// when a page loads,mounted() will be call
	mounted() {
		this.resetSearchForm();
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyuserid = userdetail.userid;
		this.useremail = userdetail.email;
		// this.clientid = userdetail.clientid;
		// this.userwarehouse = userdetail.warehouseid;
		this.pageno = 0;
		// this.getClientList();
		// this.getWarehouseList();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		selectmrp(data) {
			this.selectedmrp = data;
			this.stockupdate.mrp = data.value;
			this.checkmrp()
		},
		getstnBoxtypeData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: this.pageno,
				limit: 10,
				id: this.id.trim(),
				boxtype: this.boxtype.trim(),
				warehouseid: localStorage.getItem("selectedWarehouse"),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'stnboxtypelist',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listBoxtypeData = result.data.rows
					let totalRows = result.data.count
					if (totalRows < 10) {
						this.pagecount = 1
					} else {
						this.pagecount = Math.ceil(totalRows / 10)
					}
				}, error => {
					console.error(error)
				})
		},

		checkcorrectiontype() {
			if (this.stockupdate.correctiontype == 'receipt') {
				this.receipttype = true;
				this.mrpList = []
				this.selectedmrp = {}
				this.stockupdate.qty = '';
				this.MRPErr = ''
			} else {
				this.receipttype = false;
				this.stockupdate.qty = '';
				this.MRPErr = ''
			}
			this.resetNewForm();
			this.checkrackid();
			this.checkmrp();
			this.checkproductid();
		},
		getMerchantname() {
			if (this.stockupdate.rackid != '')
				var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				rackno: this.stockupdate.rackid.trim(),
				clientid: localStorage.getItem("selectedClient")
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'RacknMerchantcheck',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.data.merchantname) {
						this.isMultiseller = true;
						this.isMultisellermessage = result.data.data.merchantname;
					}
					if (!result.data.data.merchantname)
						this.isMultiseller = false;
					this.stockupdate.productid = null;
					this.stockupdate.mrp = null;
					this.stockupdate.lotnumber = null;
					this.stockupdate.qty = null;
					this.stockupdate.mfgdate = null;
					this.stockupdate.shelflife = null;
					this.stockupdate.expirydate = null;
					this.rackisnotvalidmrp = false;
					this.isvalidproductid = false;
					this.isnotvalidproductid = false;
					this.isvalidmrp = false;
					this.isnotvalidmrp = false;
					this.isvalidlotnumber = false;
					this.isnotvalidlotnumber = false;
				}, error => {
					console.error(error)
				})
		},

		checkrackid() {
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.listBoxtypeData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.correctiontype == '' || this.stockupdate.correctiontype == null) {
				this.StockcorrErr = this.$t('auditReport.stockCorrectionTypeError');
				this.listBoxtypeData = [];

				return false;
			}

			if (this.stockupdate.rackid != '' && this.stockupdate.rackid != '') {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					rackno: this.stockupdate.rackid.trim(),
					warehouseid:localStorage.getItem("selectedWarehouse"),
					clientid: localStorage.getItem("selectedClient"),
					userid: this.createdbyuserid,
					sctype: this.stockupdate.correctiontype,
				});

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'validateRack',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (result.data.errorCode == 0) {
							this.isvalidrackid = true;
							this.isnotvalidrackid = false;
							this.invalidRackMessage = this.$t('auditReport.InvalidrackId');;
							this.resetNewForm();
							this.checkproductid();
							this.checkmrp();
							this.checklotnumber();
						} else {
							this.invalidRackMessage = result.data.msg ? result.data.msg : this.$t('auditReport.InvalidrackId');
							this.isvalidrackid = false;
							this.isnotvalidrackid = true;
						}
					}, error => {
						this.isvalidrackid = false;
						this.isnotvalidrackid = true;
						this.invalidRackMessage = this.$t('auditReport.InvalidrackId');
						console.error(error)
					})
			}
		},

		checkproductid() {
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.listBoxtypeData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.correctiontype == '' || this.stockupdate.correctiontype == null) {
				this.StockcorrErr = this.$t('auditReport.stockCorrectionTypeError');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.rackid == '') {
				this.RackErr = this.$t('auditReport.rackIDRequired');
				this.listBoxtypeData = [];
				return false;
			}

			if (this.stockupdate.productid != '') {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					productid: this.stockupdate.productid.trim(),
					rackid: this.stockupdate.rackid.trim(),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					crtype: this.stockupdate.correctiontype.trim(),
					mrp: 0,
					lotno: '',
					clientid: localStorage.getItem("selectedClient")
				});
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkProductInRack',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (result.data.errorCode == 0) {
							this.producterrormsg = ''
							this.isvalidproductid = true;
							this.isnotvalidproductid = false;
							this.isvalidmrp = false;
							this.stockupdate.mrp = '';
							this.mrpList = [];
							this.selectedmrp = {};
							this.listmrpData = result.data.getMrpList.data
							for (var i = 0; i < this.listmrpData.length; i++) {
								this.mrpList.push({
									'value': this.listmrpData[i].mrp,
									'text': this.listmrpData[i].mrp
								});
							}
							this.checkmrp();
							this.checklotnumber();
						} else {
							this.producterrormsg = result.data.msg
							this.isvalidproductid = false;
							this.isnotvalidproductid = true;
							this.isvalidmrp = false;
							this.stockupdate.mrp = ''
							this.mrpList = []
							this.selectedmrp = {}
						}
					}, error => {
						console.error(error)
					})
			}
		},

		checkmrp() {
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.listBoxtypeData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.correctiontype == '' || this.stockupdate.correctiontype == null) {
				this.StockcorrErr = this.$t('auditReport.stockCorrectionTypeError');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.rackid == '') {
				this.RackErr = this.$t('auditReport.rackIDRequired');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.productid == '') {
				this.ProductErr = this.$t('consolidation.productIdRequiredErr');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.mrp != '' && this.stockupdate.mrp != null && this.stockupdate.mrp != undefined) {
				this.MRPErr = '';
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					productid: this.stockupdate.productid.trim(),
					rackid: this.stockupdate.rackid.trim(),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					crtype: this.stockupdate.correctiontype.trim(),
					mrp: this.stockupdate.mrp,
					lotno: '',
					clientid: localStorage.getItem("selectedClient")
				});
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkProductInRack',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (result.data.errorCode == 0) {
							//  this.producterrormsg=''
							this.rackisnotvalidmrp = false;
							this.isvalidmrp = true;
							this.isnotvalidmrp = false;
							this.islotcontrol = result.data.data[0].islotcontrol
							this.isexpirycontrol = result.data.data[0].isexpirycontrol
							this.whcurrentstock = result.data.data[0].whcurrentstock
							this.checklotnumber();
						} else {
							//  this.producterrormsg=result.data.msg
							if (this.stockupdate.correctiontype == 'receipt') {
								this.rackisnotvalidmrp = true;
							} else {
								this.isnotvalidmrp = true;
							}
							this.whcurrentstock = 0
							this.isvalidmrp = false;
							this.islotcontrol = 0;
							this.isexpirycontrol = 0;
						}
					}, error => {
						console.error(error)
					})
			}
		},

		checklotnumber() {
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.listBoxtypeData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.correctiontype == '' || this.stockupdate.correctiontype == null) {
				this.StockcorrErr = this.$t('auditReport.stockCorrectionTypeError');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.rackid == '') {
				this.RackErr = this.$t('auditReport.rackIDRequired');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.productid == '') {
				this.ProductErr = this.$t('consolidation.productIdRequiredErr');
				this.listBoxtypeData = [];
				return false;
			}
			if (this.stockupdate.mrp == '' || this.stockupdate.mrp == null || this.stockupdate.mrp == undefined) {
				this.MRPErr = this.$t('auditReport.mrpRequired');
				this.listBoxtypeData = [];
				return false;
			}

			if (this.stockupdate.lotnumber != '') {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					productid: this.stockupdate.productid.trim(),
					rackid: this.stockupdate.rackid.trim(),
					warehouseid: localStorage.getItem("selectedWarehouse"),
					crtype: this.stockupdate.correctiontype.trim(),
					mrp: this.stockupdate.mrp,
					lotno: this.stockupdate.lotnumber,
					clientid: localStorage.getItem("selectedClient")
				});
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkProductInRack',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (result.data.errorCode == 0) {
							this.loterrormsg = '';
							this.whcurrentstock = result.data.data[0].whcurrentstock
							this.stockupdate.expirydate = result.data.data[0].expirydate
							this.isvalidlotnumber = true;
							this.isnotvalidlotnumber = false;
							this.checkqty();
						} else {
							this.stockupdate.expirydate = '';
							this.whcurrentstock = 0
							this.loterrormsg = result.data.msg
							this.isvalidlotnumber = false;
							this.isnotvalidlotnumber = true;
						}
					}, error => {
						console.error(error)
					})
			}
		},

		checkqty() {
			this.QuantityrErr = '';
			if (this.stockupdate.qty != '' && this.stockupdate.correctiontype == 'issue') {
				if (Number(this.stockupdate.qty) > Number(this.whcurrentstock)) {
					this.qtyerror = true;
					this.qtyerrormsg = this.$t('stockCorrectionReport.qtyCannotExceed');
				} else {
					this.qtyerror = false;
					this.qtyerrormsg = ''
				}
			} else {
				this.qtyerror = false;
				this.qtyerrormsg = ''
			}

		},

		checkmfgdate() {
			var mfgdate = this.stockupdate.mfgdate;
			if (mfgdate !== '' && mfgdate !== null) {
				var sd = new Date(mfgdate);
				var ed = new Date();
				//This condition means the end date is bigger even if the comparison says otherwise
				//Can work without Parse
				if (Date.parse(sd) > Date.parse(ed)) {
					this.mfgerror = true;
					this.mfgerrormsg = this.$t('auditReport.manufactureDateErr');
					this.lotitems[index].lotmfgdate = null;
				} else {
					this.shelflifeChanged();
					this.mfgerror = false;
					this.mfgerrormsg = "";
				}
			}
		},

		checkshelflife() {
			if (this.stockupdate.shelfLife != '') {
				this.shelflifeChanged();
			}
		},

		shelflifeChanged() {
			var shelflife = this.stockupdate.shelflife;
			var ltdate = this.stockupdate.mfgdate;
			if ((shelflife != '' && shelflife != null && shelflife != 'undefined') && (ltdate != '' && ltdate != null)) {
				var mfg = this.stockupdate.mfgdate;
				var exprirydate = new Date(mfg);
				var shelflifeduration = shelflife;
				exprirydate.setMonth(exprirydate.getMonth() + Number(shelflifeduration));
				var newexpirydate = new Date(exprirydate);
				this.stockupdate.expirydate = this.getdate1(exprirydate);
			} else {
				return false;
			}
		},

		checkexpirydate() { },

		stockcorrection(scope) {
			if (this.islotcontrol != 1) {
				var lotnumber = '';
				var expirydate = '';
			} else {
				if (this.stockupdate.lotnumber == '') {
					return false;
				}
				var lotnumber = this.stockupdate.lotnumber;
				if (this.stockupdate.expirydate) {
					var expirydate = this.stockupdate.expirydate;
				} else {
					var expirydate = '';
				}
			}
			var err = 0;
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.listBoxtypeData = [];
				err++;
			}

			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.listBoxtypeData = [];
				err++;
			}

			if (this.stockupdate.correctiontype == '' || this.stockupdate.correctiontype == null) {
				this.StockcorrErr = this.$t('auditReport.stockCorrectionTypeError');
				this.listBoxtypeData = [];
				err++;
			}

			if (this.stockupdate.rackid == '') {
				this.RackErr = this.$t('auditReport.rackIDRequired');
				this.listBoxtypeData = [];
				err++;
			}

			if (this.stockupdate.productid == '') {
				this.ProductErr = this.$t('consolidation.productIdRequiredErr');
				this.listBoxtypeData = [];
				err++;
			}

			if (this.stockupdate.mrp == '' || this.stockupdate.mrp == null || this.stockupdate.mrp == undefined) {
				this.MRPErr = this.$t('auditReport.mrpRequired');
				this.listBoxtypeData = [];
				err++;
			}

			if (this.stockupdate.qty == '' || this.stockupdate.qty == null) {
				this.QuantityrErr =  this.$t('auditReport.quantityError');
				this.listBoxtypeData = [];
				err++;
			}

			if (this.stockupdate.correctionreason == '' || this.stockupdate.correctionreason == null) {
				this.CorrectionreasonErr = this.$t('auditReport.correctionEror');
				this.listBoxtypeData = [];
				err++;
			}

			if (this.qtyerrormsg != '') {
				err++;
			}

			if (err > 0)
				return false;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				productid: this.stockupdate.productid.trim(),
				rackid: this.stockupdate.rackid.trim(),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				crtype: this.stockupdate.correctiontype.trim(),
				mrp: this.stockupdate.mrp,
				quantity: this.stockupdate.qty,
				lotno: lotnumber,
				clientid: localStorage.getItem("selectedClient"),
				expirydate: expirydate,
				reason: this.stockupdate.correctionreason,
				comment: this.stockupdate.comments,
				useremail: this.useremail,
				userid: this.createdbyuserid,
			});
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'updateCorrection',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					document.getElementById("save").disabled = true;
					if (result.data.errorCode == 0) {
						document.getElementById("save").disabled = false;
						var cursor = document.getElementById('productid');
						cursor.focus();
						this.$alertify.success(result.data.msg);
						this.resetNewForm();
					} else if (result.data.errorCode == -2) {
						this.$alertify.error(result.data.msg);
						document.getElementById("save").disabled = false;
					} else {
						this.$alertify.error(result.data.msg);
						document.getElementById("save").disabled = false;
					}
					this.isLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},

		getElementByIdFn(elmId, val) {
			document.getElementById(elmId).value = val;
		},

		getdate1(date) {
			var today = new Date(date);
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = '0' + dd;
			}
			if (mm < 10) {
				mm = '0' + mm;
			}
			var today = yyyy + '-' + mm + '-' + dd;
			return today;
		},

		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.stockupdate.correctiontype = null;
		// 		this.stockupdate.correctionreason = null;
		// 		this.stockupdate.comments = '';
		// 		this.stockupdate.rackid = null;
		// 		this.stockupdate.productid = null;
		// 		this.stockupdate.mrp = null;
		// 		this.stockupdate.lotnumber = null;
		// 		this.stockupdate.qty = null;
		// 		this.stockupdate.mfgdate = null;
		// 		this.stockupdate.shelflife = null;
		// 		this.stockupdate.expirydate = null;
		// 		this.mrpList = []
		// 		this.selectedmrp = {}
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.isvalidrackid = false;
		// 			this.isnotvalidrackid = false;
		// 			this.isMultiseller = false;
		// 			this.isnotvalidproductid = false;
		// 			this.isnotvalidlotnumber = false;
		// 			this.rackisnotvalidmrp = false;
		// 			this.isnotvalidmrp = false;
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.isvalidrackid = false;
		// 				this.isnotvalidrackid = false;
		// 				this.isMultiseller = false;
		// 				this.isnotvalidproductid = false;
		// 				this.isnotvalidlotnumber = false;
		// 				this.rackisnotvalidmrp = false;
		// 				this.isnotvalidmrp = false;
		// 			}
		// 		}
		// 	}
		// 	this.listStockData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getStockData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1) * 10
			this.getstnBoxtypeData()
		},

		resetSearchForm() {
			this.stockupdate = {
				correctiontype: null,
				rackid: '',
				productid: '',
				mrp: '',
				lotnumber: '',
				qty: '',
				mfgdate: '',
				shelflife: '',
				expirydate: '',
				correctionreason: null,
				comments: '',
			};
			this.rackiderror = '';
			this.isnotvalidrackid = false;
			this.invalidRackMessage = this.$t('auditReport.InvalidrackId');
			this.isvalidrackid = false;
			this.isvalidproductid = false;
			this.isnotvalidproductid = false;
			this.isvalidmrp = false;
			this.isnotvalidmrp = false;
			this.rackisnotvalidmrp = false;
			this.isvalidlotnumber = false;
			this.isnotvalidlotnumber = false;
			this.producterrormsg = '';
			this.islotcontrol = 0;
			this.isexpirycontrol = 0;
			this.loterrormsg = '';
			this.whcurrentstock = 0;
			this.qtyerror = false;
			this.qtyerrormsg = '';
			this.mfgerrormsg = '';
			this.mfgerror = false;
			this.shelflifeerror = false;
			this.shelflifeerrormsg = '';
			this.expirydateerror = false;
			this.expirydateerrormsg = '';

			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		resetNewForm() {
			this.$validator.reset();
			document.getElementById("save").disabled = false;
			this.isLoading = false;
			this.stockupdate.productid = '';
			this.stockupdate.qty = '';
			this.MRPErr = '';
			document.getElementById("productid").value = '';
			this.isvalidproductid = false;
			this.isnotvalidproductid = false;
			this.ProductErr = '';
			this.producterrormsg = '';
			this.stockupdate.mrp = '';
			this.mrpList = []
			this.selectedmrp = {}
			document.getElementById("mrp").value = '';
			this.isvalidmrp = false;
			this.isnotvalidmrp = false;
			document.getElementById("qty").value = '';
			this.qtyerror = false;
			this.qtyerrormsg = '';
			this.stockupdate.lotnumber = '';
			document.getElementById("lotnumber").value = '';
			this.isvalidlotnumber = false;
			this.isnotvalidlotnumber = false;
		},

		onSubmit: function (e) {
			this.$validator
				.validateAll()
				.then(() => {
					console.log("form is valid", this.model);
					event.target.reset();
				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/stockCorrection/stockcorrection.component.js